import { isNud } from '@/shared/utilities/typing'
import { dateYmd } from '@/shared/utilities/date-format';
import AccountUser from '@/shared/models/entities/account-user';

/**
 * ミルキクアート デザイン・工芸: 参加生徒回答エンティティ
 */
class AttendedStudentAnswer {
    attended_student_id;
    account_user_id;
    account_user;
    work_1_1;
    work_2_1;
    work_2_2;
    work_2_3;
    work_2_submit_datetime;
    work_3_1;
    work_3_2;
    work_3_3;
    work_3_submit_datetime;
    images;

    constructor(properties) {
        if (isNud(properties)) {
            properties = {};
        }

        this.attended_student_id = properties.attended_student_id;
        this.account_user_id = properties.account_user_id;
        this.account_user = new AccountUser(properties.account_user);
        this.work_1_1 = properties.work_1_1 ?? '';
        this.work_2_1 = properties.work_2_1;
        this.work_2_2 = properties.work_2_2;
        this.work_2_3 = properties.work_2_3;
        this.work_2_submit_datetime = properties.work_2_submit_datetime;
        this.work_3_1 = properties.work_3_1;
        this.work_3_2 = properties.work_3_2;
        this.work_3_3 = properties.work_3_3;
        this.work_3_submit_datetime = properties.work_3_submit_datetime;
        this.images = properties.images;
    }

    get work_2_submit_datetime_display() {
        return dateYmd(this.work_2_submit_datetime);
    }

    get work_3_submit_datetime_display() {
        return dateYmd(this.work_3_submit_datetime);
    }
}

export default AttendedStudentAnswer;
